import React, { useEffect, useRef } from "react";
import "./Aiplatform.css";
import { useTranslation } from "react-i18next";

function Aiplatform() {
  const { t } = useTranslation();
  const fadeInRef = useRef(null); 

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.1 }
    );

    const fadeInElement = fadeInRef.current;
    if (fadeInElement) {
      observer.observe(fadeInElement);
    }

    return () => {
      if (fadeInElement) observer.unobserve(fadeInElement);
    };
  }, []);

  return (
    <div id="ai-content" className="centraliz-content">
      <div className="text-ai-platfrom">
        <div className="text-header-centraliz">AI Platform</div>
        <div className="sub-header-centraliz">{t("main_head_ai")}</div>
      </div>
      <div className="ai-image">
        <div className="centraliz-image-header">AI Platform</div>
        <div className="centraliz-image-sub">
          <li>{t("main_sub_ai_1")}</li>
          <li>{t("main_sub_ai_2")}</li>
          <li>{t("main_sub_ai_3")}</li>
          <li>{t("main_sub_ai_4")}</li>
        </div>
      </div>
    </div>
  );
}

export default Aiplatform;
